import React, { useContext } from "react";
import { LegacyCard as Card, Collapsible, Text, Layout, BlockStack } from "@shopify/polaris";
import { DropZone } from "lib/components";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const FinishCover = () => {
  const { FINISH_COVER, ONBOARD_IMAGE_TYPE } = constant;
  const { finishCoverImage, handleChange } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { finish, updatedAt: brandUpdatedAt = "" } = brand || {};
  const { cover: finishCover } = finish || {};
  const { updatedAt = "" } = finishCover || {};
  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.finishCover.title")}
        description={cms("section.finishCover.description")}
      >
        <Card
          title={[
            cms("section.finishCover.card.title"),
            updatedAt ? (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ) : (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(brandUpdatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.finishCover.card.subDescription")}</BlockStack>
            <br />
            <DropZone
              size={10}
              allowedTypes={ONBOARD_IMAGE_TYPE}
              id="dropZone"
              onAdd={(value) => handleChange(FINISH_COVER, (value && value.length && value[0]) || "", FINISH_COVER)}
              onRemove={() => handleChange(FINISH_COVER, "", FINISH_COVER)}
              fileList={(finishCoverImage !== "" && [finishCoverImage]) || []}
              allowMultiple={false}
            />
            <br />
            <Text variant="bodySm" as="p">
              {cms("section.finishCover.card.caption")}
            </Text>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(FinishCover), {
  feature: constant.STANDARD_BRANDING,
});
